import { render, staticRenderFns } from "./WidgetDatatableSlot.vue?vue&type=template&id=a2bf56a2&scoped=true&"
import script from "./WidgetDatatableSlot.vue?vue&type=script&lang=js&"
export * from "./WidgetDatatableSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf56a2",
  null
  
)

export default component.exports